/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Event_Warning_Lines_TitleInputs */

const en_event_warning_lines_title = /** @type {(inputs: Event_Warning_Lines_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Line count warning: line count (${i?.count}) is above max value`)
};

const fr_event_warning_lines_title = /** @type {(inputs: Event_Warning_Lines_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alerte lignes : le nombre de lignes (${i?.count}) dépasse la valeur maximale`)
};

const de_event_warning_lines_title = /** @type {(inputs: Event_Warning_Lines_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Warnung zur Zeilenanzahl: Die Zeilenanzahl (${i?.count}) überschreitet den Maximalwert.`)
};

const it_event_warning_lines_title = /** @type {(inputs: Event_Warning_Lines_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avviso conteggio righe: il conteggio righe (${i?.count}) è superiore al valore massimo`)
};

const ru_event_warning_lines_title = /** @type {(inputs: Event_Warning_Lines_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предупреждение о количестве строк: количество строк (${i?.count}) превышает максимальное значение.`)
};

const es_event_warning_lines_title = /** @type {(inputs: Event_Warning_Lines_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Advertencia de conteo de líneas: el conteo de líneas (${i?.count}) es superior al valor máximo`)
};

const zh_cn2_event_warning_lines_title = /** @type {(inputs: Event_Warning_Lines_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`行数警告：行数 (${i?.count}) 超过最大值`)
};

const ja_event_warning_lines_title = /** @type {(inputs: Event_Warning_Lines_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`行数警告: 行数 (${i?.count}) が最大値を超えています`)
};

const hi_event_warning_lines_title = /** @type {(inputs: Event_Warning_Lines_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पंक्ति गणना चेतावनी: पंक्ति गणना (${i?.count}) अधिकतम मान से अधिक है`)
};

const pt_pt2_event_warning_lines_title = /** @type {(inputs: Event_Warning_Lines_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aviso de contagem de linhas: a contagem de linhas (${i?.count}) está acima do valor máximo.`)
};

/**
* | output |
* | --- |
* | "Line count warning: line count ({count}) is above max value" |
*
* @param {Event_Warning_Lines_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_lines_title = /** @type {((inputs: Event_Warning_Lines_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Lines_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_lines_title(inputs)
	if (locale === "de") return de_event_warning_lines_title(inputs)
	if (locale === "it") return it_event_warning_lines_title(inputs)
	if (locale === "ru") return ru_event_warning_lines_title(inputs)
	if (locale === "es") return es_event_warning_lines_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_lines_title(inputs)
	if (locale === "ja") return ja_event_warning_lines_title(inputs)
	if (locale === "hi") return hi_event_warning_lines_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_lines_title(inputs)
	return en_event_warning_lines_title(inputs)
});